import { Component } from '@angular/core';
import { RecipientsFormComponent } from '../../../../../components/forms/campaignforms/recipients-form/recipients-form.component';
import { RecipientsPreviewComponent } from '../../../../../components/forms/campaignpreviews/recipients-preview/recipients-preview.component';

/** Wizard step 2: recipient groups, with the live unique audience. */
@Component({
  selector: 'app-recipients',
  standalone: true,
  imports: [RecipientsFormComponent, RecipientsPreviewComponent],
  templateUrl: './recipients.component.html',
  styleUrl: '../wizard-step.css',
})
export class RecipientsComponent {}
